module.exports = __webpack_public_path__ + "man.65fc6703778c0d1f23d8.png";